/** Preferencia POS: grilla solo productos físicos con stock en la sucursal actual (`AsyncStorage`). */
export const POS_GRID_PHYSICAL_STOCK_ONLY_STORAGE_KEY = '@vuelto_pos_grid_physical_stock_only';

/** Ítems por página en grilla POS (mobile). */
export const POS_CATALOG_PAGE_SIZE_STORAGE_KEY = '@vuelto_pos_catalog_page_size';

/** Ítems por página en grilla POS (wide / PC). */
export const POS_CATALOG_WIDE_PAGE_SIZE_STORAGE_KEY = '@vuelto_pos_catalog_page_size_wide';

export type PosCatalogPageSizePreset = 'compact' | 'wide';

/**
 * Mobile POS: carrito compacto (más espacio para el catálogo).
 * Solo afecta viewport estrecho; desktop/wide sin cambios.
 */
export const POS_MOBILE_CART_COMPACT_LAYOUT = true;

/**
 * Mobile POS: carrito en barra fija + bottom sheet.
 * Requiere carrito compacto activo para el contenido del sheet; desktop/wide sin cambios.
 */
export const POS_MOBILE_CART_SHEET_LAYOUT = true;

/** Altura estimada de la barra fija del carrito mobile (padding del catálogo). */
export const POS_MOBILE_CART_BAR_HEIGHT = 52;

/** Padding superior de la grilla catálogo en desk (sync con `usePosCatalogLayout`). */
export const POS_DESK_CATALOG_GRID_PADDING_TOP = 10;

/** Aire entre rail / fulfillment (listHeader desk) y la primera fila de productos. */
export const POS_DESK_CATALOG_RAIL_TO_GRID_GAP = 12;

/** Gutter horizontal compartido: toolbar catálogo, grilla y paginación (desk). */
export const POS_DESK_CATALOG_GUTTER = 12;

/** Desk ancho: tope del buscador en toolbar (proto flex:1 + cap en monitores grandes). */
export const POS_DESK_SEARCH_MAX_WIDTH = 520;

/** Viewport mínimo para aplicar `POS_DESK_SEARCH_MAX_WIDTH`. */
export const POS_DESK_SEARCH_MAX_WIDTH_MIN_VIEWPORT = 1280;

/** Hint de lector / F2 — solo accesibilidad (sin línea bajo el buscador en desk). */
export const POS_SEARCH_BARCODE_ACCESSIBILITY_HINT = 'Lector USB. F2 para enfocar.';

/**
 * Mobile: techo del bloque fijo (buscador + rail) para dejar ~65%+ del viewport a la grilla.
 * Si no entra, el header scrollea verticalmente (`PosScreen`).
 */
export const POS_MOBILE_CATALOG_HEADER_MAX_VIEWPORT_FRACTION = 0.32;
